export const tw = {
    'common': {
        'warn': '溫馨提示',
        'success': '成功',
        'ok': '確認',
        'cancle': '取消',
        'modify': '修改',
        'delete': '刪除',
        'error': '錯誤信息',
        'loading': '正在加載中...',
        'your-position': '您的位置：',
        'home-page': '首頁',
        'search': '搜索',
        'fold': '摺疊',
        'clear': '清空',
        'search-advanced': '高級搜索',
        'export-excel': '導出Excel',
        'print-pdf': '列印',
        'unfold': '展開',
        'fold-all': '全部收起',
        'unfold-all': '全部展開',
        'collapse': '收起',
        'no-data': '沒有符合條件的數據',
        'authentication-error': '權限錯誤',
        'request-error': '請求出錯',
        'start-date': '開始日期',
        'end-date': '結束日期',
        'sort': '排序',
        'asc': '升序',
        'desc': '降序',
        'unknown-error': '未知錯誤',
        'setup-column': '配置列表',
        'setup-save': '保存配置',
        'setup-width': '列寬',
        'purchase-type': '訂單性質',
        'purchase-date': '訂單日期',
        'unfold-detail': '展開明細',
        'fold-detail': '隱藏明細',
        'download': '下載',
        'submit': '提交',
        'back': '返回',
        'extension': '擴展字段',
        'operate': '操作',
        'edit': '編輯',
        'please-select': '請選擇',
        'none-data': '暫無數據',
        'save': '保存',
        '备注': '備註',
        'inquiry-publicly': '詢價公開',
        'supplier-registration': '供應商註冊',
        'contact-us': '聯系我們',
        'name-tip': '請輸入用戶名!',
        'no-name': '用戶名不存在!',
        'email-tip': '請輸入郵箱!',
        'email-error': '郵箱格式不合法!',
        'account-login': '賬戶登錄',
        'forget-password': '忘記密碼',
        'enter-account': '請輸入賬戶',
        'enter-password': '請輸入密碼',
        'password-again': '請再次輸入密碼',
        'password-different': '兩次輸入的密碼不壹致',
        'get-code': '獲取驗證碼',
        'confirm-modification': '確認修改',
        'account': '賬號',
        'code': '驗證碼',
        'enter-code': '請輸入驗證碼',
        'code-tip': '驗證碼為6位數字',
        'enter-pwd': '請輸入新密碼',
        'pwd-tip': '密碼長度應為1-16位',
        'pwd-again': '請再次輸入新密碼',
        'pwd-different': '兩次輸入的密碼不壹致'
    },
    'user': {
        'user-center': '個人中心',
        'modify-password': '修改密碼',
        'modify-info': '修改資料',
        'modify-password-success': '修改密碼成功',
        'modify-info-success': '修改用護信息成功',
        'email-wrong-format': '郵箱格式不正確！',
        'phone-wrong-format': '電話格式不正確！',
        'mobile-wrong-format': '手機格式不正確！',
        'userInfo': '用戶信息',
        'no': '工號',
        'noInfo': '工號是必填信息',
        'nameRequired': '姓名是必填信息',
        'emailRequired': '郵箱是必填信息',
        'name': '姓名',
        'loginName': '登錄名',
        'loginNameInfo1': '該用戶名已被註冊！',
        'loginNameInfo2': '登錄名是必填信息！',
        'loginNameInfo3': '登錄名只能是字母數字下劃線！',
        'loginNameInfo4': '登錄名最少四位！',
        'loginNameInfo5': '最大長度不能超過50位!',
        'newPassword': '密碼',
        'passwordInfo': '若不修改請留白',
        'newPasswordInfo1': '密碼不能為空!',
        'newPasswordInfo2': '密碼長度不得少於三位！',
        'confirmNewPassword': '確認密碼',
        'confirmNewPasswordInfo': '兩次密碼輸入不一致！',
        'ent': '默認企業編碼',
        'entInfo': '企業編碼不能為空!',
        'loginFlag': '是否允許登錄',
        'loginFlag1': '允許',
        'loginFlag2': '不允許',
        'userAuthority': '用戶權限',
        'userRole': '用戶角色',
        'userRoleInfo': '如果修蓋自己的角色，修蓋成功后需要重新登錄',
        'nzTitle': '非必填(點擊展開)',
        'email': '郵箱',
        'phone': '電話',
        'mobile': '手機',
        'site': '據點',
        'defaultSite': '默認據點',
        'employeeNo': 'ERP用戶編號',
        'employeeName': 'ERP員工姓名',
        'departmentNo': '部門編碼',
        'departmentName': 'ERP部門名稱',
        'ware': '默認倉庫',
        'remarks': '備註',
        'userList': '用戶列表',
        'userAdd': '新增用戶',
        'userAdded': '用戶已添加',
        'userEdit': '用戶編輯',
        'editSuccess': '修改成功',
        'name-placeholder': '真實名稱',
        'loginName-placeholder': '登錄名稱',
        'companyName': '供應商名稱',
        'officeName': '部門名稱',
        'mobile-placeholder': '手機號碼',
        'operate': '操作',
        'edit': '編輯',
        'delete': '刪除',
        'warnInfo1': '確認刪除該用戶？',
        'current-account-no': '您當前的賬號',
        'modifier': '修 改',
        'login-password': '登錄密碼',
        'login-password-tip': '為保護賬戶安全，建議您定期更改密碼',
        'personal-data': '個人資料',
        'update-timely': '如果您的個人資料有變化，請及時更新',
        'old-password': '舊密碼',
        'new-password': '新密碼',
        'confirm-new-password': '確認新密碼',
        'user-tip': '用戶默認集團有誤，請重新選擇'
    },
    'shared': {
        'all': '全部',
        'loading': '正在加載中',
        'yes': '是',
        'no': '否',
        'page-total-count': '共{{totalNum}}條，',
        'page-total-pages': '共{{totalPage}}頁，',
        'page-goto': '到',
        'page': '頁',
        'page-previous': '上一頁',
        'page-first': '首頁',
        'page-next': '下一頁',
        'page-last': '末頁',
        'page-each': '每頁',
        'page-each-count': '條，',
        'table-colName': '配置字段',
        'table-sort': '顯示順序',
        'table-width': '顯示列寬',
        'table-orderField': '查詢排序',
        'table-orderType': '升降序',
        'table-not-surported': '暫不支持排序'
    },
    'home': {
        'common': {
            'anounce-list': '公告列表',
            'anounce-detail': '公告详情',
            'message-list': '訊息列表',
            'welcome': '歡迎來到雲供應商平臺',
            'supplier': '雲供應商',
            'ent': '集團：',
            'title-home': '首页',
            'title-login': '登錄',
            'title-register': '註冊',
            'title-anounce': '公告',
            'title-anounce-detail': '全文',
            'title-message': '我的訊息',
            'find-psd': '找回密碼',
            'today-order': '今日訂單',
            'unconfirmed-order': '未確認訂單',
            'overdue-order': '逾期未出貨訂單',
            'order-transit': '送貨在途訂單',
            'get-code': '獲取驗證碼',
            'confirm-modification': '確認修改'

        },
        'login': {
            'select-language': '選擇語言',
            'please-fill-userid': '請填寫賬號',
            'please-fill-password': '請填寫密碼',
            'user-placeholder': '用戶名',
            'password-placeholder': '密碼',
            'login': '登錄',
            'login-now': '立即登錄',
            'logout': '登出',
            'platform': '雲交貨協同平臺',
            'zhilink-home': '智互聯官網',
            'zhilink-copyright': '技術支持:©{{year}} 智互聯（深圳）科技有限公司',
            'owner-website': '官方網站',
            'owner-copyright': '©CopyRight {{year}}',
            'owner-copyright2': '版權所有',
            'owner-phone': '聯繫電話:',
            'owner-mail': '聯繫郵箱:'
        },
        'register': {
            'form-title': '供應商註冊信息',
            'success': '信息提交成功，請等待審覈，近期請注意留意郵箱！'
        },
        'notfound': {
            'not-found-page': '出錯啦,您訪問的頁面沒有找到!',
            'redirect-after-seconds': '{{count}}秒後自動跳轉...',
            'redirect-imediately': '立即跳轉'
        },
        'anounce': {
            'title': '標題',
            'date': '日期',
            'more': '查看更多',
            'no-more-data': '沒有更多公告了'
        },
        'message': {
            'title': '標題',
            'please-select-category': '請選擇消息分類:',
            'all': '全部',
            'read': '已讀',
            'unread': '未讀',
            'mark-as-read': '全部標爲已讀'
        }
    },
    'other': {
        '温馨提示': '溫馨提示',
        '收货仓库': '收貨倉庫',
        '仓库储位': '倉庫儲位',
        '已結案訂單明細': '已結案訂單明細',
        '有答交日期在今天之前，': '有答交日期在今天之前',
        '交总数量小于产品数量，': '交總數量小於產品數量',
        '您确定要保存吗？': '您確定要保存嗎？'
    }
};



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/i18n/zh-TW.ts